export default "__VITE_ASSET__CUdOTwg$__"